import { ApplicationCreationSources } from '../../enums';

export class LoginDetails {
	public Mobile: string;
	public SnklRefId?: string;
	public AppExists?: boolean;
	public Source: ApplicationCreationSources;
	public LeadId?: string;
	public Code: string;
	public LgCode: string;
	public LcCode: string;
	public SourceCode: string;

	constructor() {
		this.Source = ApplicationCreationSources.HSLDAO;
	}
}

